import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { FormattedDate, FormattedCalendarDate } from 'components/Formatters';
import { WarningAlert } from 'components/Alerts';
import { SelfServiceAPI } from 'types';

export interface ScheduledPaymentCreditCardExpiredProps extends Pick<
  SelfServiceAPI.CreditCardPaymentMethod,
  'cardType' | 'lastFourDigits'
> {
  paymentDueDate: string | Date;
  updatePaymentMethodUrl: string;
}

export const ScheduledPaymentCreditCardExpired = ({
  paymentDueDate,
  cardType,
  lastFourDigits,
  updatePaymentMethodUrl,
}: ScheduledPaymentCreditCardExpiredProps) => (
  <WarningAlert>
    <WarningAlert.Heading>
      Please update your payment details before <FormattedCalendarDate date={paymentDueDate} />, or your booking will be cancelled.
    </WarningAlert.Heading>
    <WarningAlert.Body>
      Your {cardType} credit card ending {lastFourDigits} has expired and we are unable to take final payment. To avoid your booking being
      cancelled, please update your payment details before{' '}
      <strong>
        <FormattedDate date={paymentDueDate} />
      </strong>
      .
    </WarningAlert.Body>
    <WarningAlert.Link to={updatePaymentMethodUrl} onClick={tracking.scheduledPaymentCreditCardExpiredUpdateCreditCard}>
      UPDATE CREDIT CARD
    </WarningAlert.Link>
  </WarningAlert>
);
